export default {
  CURRENCY: '€',
  DECIMALS: 2,
};
